import { Grid, WithStyles } from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox';
import grey from '@material-ui/core/colors/grey';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Paper from '@material-ui/core/Paper';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import * as React from 'react';
import { connect } from 'react-redux';
import { StaticContext } from 'react-router';
import { RouteComponentProps } from 'react-router-dom';
import { Dispatch } from 'redux';

import {
	IActResultReferenceAgenda,
	resetActResultReferenceData,
} from '../actions/imstat';
import { IUserAttr } from '../actions/session';
import { IRootState } from '../reducers';
import i18n from '../resources/i18n';
import ImstatScenarioFactory, {
	IFetchActResultReferenceParam,
} from '../scenario/ImstatScenarioFactory';
const styles = (theme: Theme) =>
	createStyles({
		cellItemName: {
			backgroundColor: grey[300],
			minWidth: '160px',
			textAlign: 'right',
			width: '20%',
		},
		cellItemValue: {
			textAlign: 'left',
			width: '80%',
		},
		paper: {
			marginTop: theme.spacing(4),
		},
		root: {
			flexGrow: 1,
			padding: theme.spacing(3),
			wordBreak: 'break-word',
		},
	});

interface IRouteParams {
	career_id: IFetchActResultReferenceParam['careerID'];
	class_id: IFetchActResultReferenceParam['classID'];
	seq: IFetchActResultReferenceParam['seq'];
}

interface IRouteState
	extends Pick<
		IFetchActResultReferenceParam,
		'imstatListStatusId' | 'reasonCode'
	> {
	skillViewFlg: boolean;
}

/**
 * 実績参照
 */
class ActResultReference extends React.Component<IProps> {
	public constructor(props: IProps) {
		super(props);
	}

	/**
	 * Lifecycle Methods
	 */
	public componentDidMount() {
		window.scrollTo({
			top: 0,
		});
		if (!this.props.match || !this.props.match.params) {
			return;
		}

		const careerID = this.props.match.params.career_id;
		const classID = this.props.match.params.class_id;
		const seq = this.props.match.params.seq;

		this.props.fetchActResultReference(this.props.token, {
			careerID,
			classID,
			imstatListStatusId: this.props.location.state.imstatListStatusId,
			reasonCode: this.props.location.state.reasonCode,
			seq,
			userAttr: this.props.userAttr,
		});
	}

	/**
	 * Lifecycle Methods
	 */
	public componentWillUnmount() {
		// データを破棄
		this.props.resetActResultReference();
	}

	/**
	 * 日程フォーマット
	 * @param date 対象日時
	 */
	public getNitteiString(date: any) {
		if (date && date.indexOf('～') !== -1) {
			date = date.replace(
				'～',
				i18n.t('～', {
					ns: 'force',
				})
			);
		}
		return date;
	}

	public render() {
		const { classes, data } = this.props;
		const skillViewFlg = this.props.location.state.skillViewFlg;
		return (
			<div className={classes.root}>
				<Paper className={classes.paper}>
					<Table>
						<TableBody>
							<TableRow>
								<TableCell className={classes.cellItemName}>
									{i18n.t('ActResultReference_0001')}
								</TableCell>
								<TableCell className={classes.cellItemValue}>
									{data.managementCode}
								</TableCell>
							</TableRow>
							<TableRow>
								<TableCell className={classes.cellItemName}>
									{skillViewFlg
										? i18n.t('ActResultReference_0002')
										: i18n.t('ActResultReference_0003')}
								</TableCell>
								<TableCell className={classes.cellItemValue}>
									{data.careerTitle}
								</TableCell>
							</TableRow>
							{skillViewFlg && (
								<TableRow>
									<TableCell className={classes.cellItemName}>
										{i18n.t('ActResultReference_0004')}
									</TableCell>
									<TableCell
										className={classes.cellItemValue}
									>
										{data.skillType === '資格' ||
										data.skillType === '業務経験' ||
										data.skillType === 'スキル診断'
											? i18n.t(data.skillType, {
													ns: 'force',
											  })
											: data.skillType}
									</TableCell>
								</TableRow>
							)}
							<TableRow>
								<TableCell className={classes.cellItemName}>
									{skillViewFlg
										? i18n.t('ActResultReference_0005')
										: i18n.t('ActResultReference_0006')}
								</TableCell>
								<TableCell className={classes.cellItemValue}>
									{data.className === '個別指定クラス' ||
									data.className === '個別実施期間'
										? i18n.t(data.className, {
												ns: 'force',
										  })
										: data.className}
								</TableCell>
							</TableRow>
							<TableRow>
								<TableCell className={classes.cellItemName}>
									{skillViewFlg
										? i18n.t('ActResultReference_0007')
										: i18n.t('ActResultReference_0008')}
								</TableCell>
								<TableCell className={classes.cellItemValue}>
									{i18n.t(data.status, { ns: 'force' })}
								</TableCell>
							</TableRow>
							<TableRow>
								<TableCell className={classes.cellItemName}>
									{skillViewFlg
										? i18n.t('ActResultReference_0009')
										: i18n.t('ActResultReference_0007')}
								</TableCell>
								<TableCell className={classes.cellItemValue}>
									{i18n.t(data.subStatus, { ns: 'force' })}
								</TableCell>
							</TableRow>
							{!skillViewFlg && (
								<TableRow>
									<TableCell className={classes.cellItemName}>
										{i18n.t('ActResultReference_0010')}
									</TableCell>
									<TableCell
										className={classes.cellItemValue}
									>
										{data.startDate == null
											? data.startDate
											: data.startDate.split(' ')[0]}
									</TableCell>
								</TableRow>
							)}
							<TableRow>
								<TableCell className={classes.cellItemName}>
									{skillViewFlg
										? i18n.t('ActResultReference_0011')
										: i18n.t('ActResultReference_0012')}
								</TableCell>
								<TableCell className={classes.cellItemValue}>
									{data.endDate == null
										? data.endDate
										: data.endDate.split(' ')[0]}
								</TableCell>
							</TableRow>
							{skillViewFlg && (
								<TableRow>
									<TableCell className={classes.cellItemName}>
										{i18n.t('ActResultReference_0013')}
									</TableCell>
									<TableCell
										className={classes.cellItemValue}
									>
										{data.validDate}
									</TableCell>
								</TableRow>
							)}
							{!skillViewFlg && (
								<TableRow>
									<TableCell className={classes.cellItemName}>
										{i18n.t('ActResultReference_0014')}
									</TableCell>
									<TableCell
										className={classes.cellItemValue}
									>
										{data.datelist &&
											data.datelist.map(
												(
													date: IActResultReferenceAgenda
												) => (
													<FormControlLabel
														control={
															<Checkbox
																id="test"
																checked={
																	date.selected ===
																	'true'
																		? true
																		: false
																}
																color="primary"
																disabled={true}
															/>
														}
														label={this.getNitteiString(
															date.nitteiString
														)}
													/>
												)
											)}
									</TableCell>
								</TableRow>
							)}
							{!skillViewFlg && (
								<TableRow>
									<TableCell className={classes.cellItemName}>
										{i18n.t('ActResultReference_0015')}
									</TableCell>
									<TableCell
										className={classes.cellItemValue}
									>
										{data.result}
									</TableCell>
								</TableRow>
							)}
							{skillViewFlg && data.scoreRegisterFlag === '1' && (
								<TableRow>
									<TableCell className={classes.cellItemName}>
										{i18n.t('ActResultReference_0015')}
									</TableCell>
									<TableCell
										className={classes.cellItemValue}
									>
										{data.result}
									</TableCell>
								</TableRow>
							)}
							{skillViewFlg &&
								data.scoreItemsRegisterFlag &&
								data.scoresList &&
								data.scoresList.map((ele, index) => {
									return (
										<TableRow key={index}>
											<TableCell
												className={classes.cellItemName}
											>
												{i18n.t(
													'ActResultReference_0016'
												)}
												{index + 1}
											</TableCell>
											<TableCell
												className={
													classes.cellItemValue
												}
											>
												<Grid
													container={true}
													spacing={4}
												>
													<Grid item={true}>
														{ele.scoreName}
													</Grid>
													<Grid item={true}>
														{ele.scores}
													</Grid>
												</Grid>
											</TableCell>
										</TableRow>
									);
								})}
							{!skillViewFlg && (
								<TableRow>
									<TableCell className={classes.cellItemName}>
										{i18n.t('ActResultReference_0017')}
									</TableCell>
									<TableCell
										className={classes.cellItemValue}
									>
										{data.studentCareerCode}
									</TableCell>
								</TableRow>
							)}
							{skillViewFlg && (
								<TableRow>
									<TableCell className={classes.cellItemName}>
										{data.certificationFlg === '1'
											? i18n.t('ActResultReference_0018')
											: i18n.t('ActResultReference_0017')}
									</TableCell>
									<TableCell
										className={classes.cellItemValue}
									>
										<Grid container={true} spacing={4}>
											<Grid item={true}>
												{data.studentCareerCode}
											</Grid>
											{data.certificationFlg === '1' && (
												<Grid item={true}>
													{data.certificationFileName}
												</Grid>
											)}
										</Grid>
									</TableCell>
								</TableRow>
							)}
							<TableRow>
								<TableCell className={classes.cellItemName}>
									{i18n.t('ActResultReference_0019')}
								</TableCell>
								<TableCell className={classes.cellItemValue}>
									{data.comment}
								</TableCell>
							</TableRow>
							<TableRow>
								<TableCell className={classes.cellItemName}>
									{skillViewFlg
										? i18n.t('ActResultReference_0020')
										: i18n.t('ActResultReference_0021')}
								</TableCell>
								<TableCell className={classes.cellItemValue}>
									{data.lecturerComment}
								</TableCell>
							</TableRow>
						</TableBody>
					</Table>
				</Paper>
			</div>
		);
	}
}

const mapStateToProps = (state: IRootState) => ({
	data: state.imstat.actResultReference,
	eLearnings: state.imstat.resultCurriculum.data,
	token: state.session.token,
	userAttr: state.session.userAttr,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	doFetchResultELearning: (token: string, userAttr: IUserAttr) => {
		const s = ImstatScenarioFactory.createDoFetchResultELearning(
			dispatch,
			token
		);
		return s.run(userAttr);
	},
	fetchActResultReference: (
		token: string,
		arg: IFetchActResultReferenceParam
	) => {
		const s = ImstatScenarioFactory.createFetchActResultReference(
			dispatch,
			token
		);
		s.run(arg);
	},
	resetActResultReference: () => dispatch(resetActResultReferenceData({})),
});

export interface IActResultReferenceProps
	extends RouteComponentProps<IRouteParams, StaticContext, IRouteState> {}

const mergeProps = (
	state: IStateProps,
	events: IDispatchProps,
	ownProps: IOwnProps
) => ({
	...state,
	...events,
	...ownProps,
});

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = ReturnType<typeof mapDispatchToProps>;
type IOwnProps = WithStyles<typeof styles> & IActResultReferenceProps;
type IProps = ReturnType<typeof mergeProps>;

const Connected = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(ActResultReference);

const Styled = withStyles(styles)(Connected);

export default Styled;



// WEBPACK FOOTER //
// ./src/containers/ActResultReference.tsx